import { Grid, makeStyles } from '@material-ui/core'
import SelectInput from 'components/common/SelectInput'
import {
  OralHygieneCategoriesByListType,
  OralHygieneListTypes,
  getOralHygieneCategoryColor
} from 'consts/oralHygieneReportConsts'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { trackEvent } from 'utils/analyticsUtils'
import OralHygieneCategoryChip from './OralHygieneCategoryChip'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  titleContainer: {
    paddingLeft: 5,
    paddingBottom: 10
  },
  dropdown: {
    borderRadius: 16
  },
  selectedValue: {
    '&&': {
      fontSize: 16,
      fontWeight: 400
    }
  },
  selectOption: {
    fontSize: 15,
    padding: '10px 20px'
  }
}))

const OralHygieneListHeader = ({
  listType,
  onListTypeSelected,
  categoryCounts = {},
  selectedCategories,
  setSelectedCategories,
  pastXDays
}) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const titleOptions = Object.values(OralHygieneListTypes).map(type => ({
    label: t(`pages.oralHygieneReport.patientsList.views.${type}`),
    value: type
  }))

  const handleCategoryClicked = useCallback(
    categoryKey => {
      const updatedCategories = selectedCategories.includes(categoryKey)
        ? selectedCategories.filter(selectedCategory => selectedCategory !== categoryKey)
        : [...selectedCategories, categoryKey]

      trackEvent('Oral Hygiene Report - Category clicked', {
        selectedCategories: updatedCategories,
        view: listType,
        pastXDays
      })
      setSelectedCategories(updatedCategories)
    },
    [selectedCategories, setSelectedCategories, listType, pastXDays]
  )

  const handleAllClicked = useCallback(() => {
    trackEvent('Oral Hygiene Report - Category clicked', {
      selectedCategories: [],
      view: listType,
      pastXDays
    })
    setSelectedCategories([])
  }, [setSelectedCategories, listType, pastXDays])

  return (
    <Grid container className={classes.root}>
      <Grid container justifyContent="flex-start" alignItems="center">
        <Grid item className={classes.titleContainer}>
          <SelectInput
            selectStyle={{ border: 'none', fontSize: 16, fontWeight: 400, marginTop: -2 }}
            style={{ bright: true, thick: true }}
            value={listType}
            options={titleOptions}
            keepErrorContainerWhenInactive={false}
            dropdownClassName={classes.dropdown}
            valueClassName={classes.selectedValue}
            optionClassName={classes.selectOption}
            onChange={({ value }) => onListTypeSelected(value)}
          />
        </Grid>
      </Grid>
      <Grid container>
        <OralHygieneCategoryChip
          label={t('pages.oralHygieneReport.patientsList.categories.all')}
          selected={selectedCategories.length === 0}
          onClick={handleAllClicked}
        />
        {OralHygieneCategoriesByListType[listType].map(category => (
          <OralHygieneCategoryChip
            key={category.key}
            label={t(`pages.oralHygieneReport.patientsList.categories.${category.key}`)}
            count={categoryCounts[category.key] || 0}
            color={getOralHygieneCategoryColor(category.key)}
            selected={selectedCategories.includes(category.key)}
            // A selected chip stays clickable so a preselection whose count drops to 0 can still be cleared.
            disabled={!categoryCounts[category.key] && !selectedCategories.includes(category.key)}
            onClick={() => handleCategoryClicked(category.key)}
          />
        ))}
      </Grid>
    </Grid>
  )
}

export default OralHygieneListHeader
